import { asyncAction, action } from 'now-frontend-shared/utils/actions';

// async actions
export const getBidedProperties = asyncAction('bidedProperties/GET_BIDED_PROPERTIES');
export const getBidsStatuses = asyncAction('bidedProperties/GET_BIDS_STATUSES');

// sync actions
export const clearState = action('bidedProperties/CLEAR_STATE');
